import smoothscroll from 'smoothscroll-polyfill'
import '../scss/bundle.scss'

// eslint-disable-next-line no-unused-vars
import whatInput from 'what-input'

import { animateInScrool, lazyImgInScrool } from './modules/helpers_function'
import Helpers from './modules/helpers'
import Layout from './modules/layout'
import Home from './modules/home'
import Audio from './modules/audio'
// import { ListPages } from './modules/list-pages'
// import { DetailPage } from './modules/detail-page'
// import { Wuoz } from './modules/wuoz'
import Accordion from './modules/accordion'

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('link[href^="blob"]')) {
    document.querySelector('link#main_styles-css').disabled = true
    // console.log('dev')
  }
})

smoothscroll.polyfill()

const helper = new Helpers()
helper.init()
const layout = new Layout()
layout.init()

if (document.querySelector('[data-page="home"]')) {
  const home = new Home(document.querySelector('[data-page="home"]'))
  home.init()
}

// if (document.querySelector('[data-page="list-pages"]')) {
//   const listPages = new ListPages(
//     document.querySelector('[data-page="list-pages"]')
//   )
//   listPages.init()
// }

if (document.querySelector('[data-page="list-pages"]')) {
  import('./modules/list-pages').then((Module) => {
    const listPages = new Module.ListPages(
      document.querySelector('[data-page="list-pages"]')
    )
    listPages.init()
  })
}
//
// if (document.querySelector('[data-page="detail"]')) {
//   const detailPages = new DetailPage(
//     document.querySelector('[data-page="detail"]')
//   )
//   detailPages.init()
// }

if (document.querySelector('[data-page="detail"]')) {
  import('./modules/detail-page').then((Module) => {
    const detailPages = new Module.DetailPage(
      document.querySelector('[data-page="detail"]')
    )
    detailPages.init()
  })
}

// if (document.querySelector('[data-page="wuoz"]')) {
//   const wuoz = new Wuoz(document.querySelector('[data-page="wuoz"]'))
//   wuoz.init()
// }

if (document.querySelector('[data-page="wuoz"]')) {
  import('./modules/wuoz').then((Module) => {
    const wuoz = new Module.Wuoz(document.querySelector('[data-page="wuoz"]'))
    wuoz.init()
  })
}

if (document.querySelectorAll('.js-audio-player').length > 0) {
  const audio = new Audio(document.querySelectorAll('.js-audio-player'))
  audio.init()
}

if (document.querySelectorAll('.lazy-conatiner').length > 0) {
  animateInScrool(document.querySelectorAll('.lazy-conatiner'))
}

if (document.querySelectorAll('.lazy-conatiner-text').length > 0) {
  animateInScrool(document.querySelectorAll('.lazy-conatiner-text'), 0.05)
}

if (document.querySelectorAll('.lazy-img').length > 0) {
  lazyImgInScrool(document.querySelectorAll('.lazy-img'))
}

if (document.querySelectorAll('details').length > 0) {
  document.querySelectorAll('details').forEach((el) => {
    // eslint-disable-next-line no-new
    new Accordion(el)
  })
}

let vh = window.innerHeight * 0.01
document.documentElement.style.setProperty('--vh', `${vh}px`)

window.addEventListener('resize', () => {
  // We execute the same script as before
  vh = window.innerHeight * 0.01
  document.documentElement.style.setProperty('--vh', `${vh}px`)
})

let vw = document.documentElement.clientWidth * 0.01
document.documentElement.style.setProperty('--vw', `${vw}px`)

window.addEventListener('resize', () => {
  // We execute the same script as before
  vw = document.documentElement.clientWidth * 0.01
  document.documentElement.style.setProperty('--vw', `${vw}px`)
})

const appHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight()
